import { createRoot } from "react-dom/client";
import App from "./App";
import './global.css';
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import store from "./store";
import { ConfigProvider } from "antd";

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
  <ConfigProvider
    theme={{
      components: {
        Button: {
          primaryShadow: 'none'
        },
        Collapse: {
          headerBg: '#fafafa'
        }
      },
      cssVar: true,
      token: {
        colorPrimary: '#393b40',
        colorInfo: '#393b40'
      }
    }}>
    <Provider store={store}>
      {/* <React.StrictMode> */}
      <App />
      {/* </React.StrictMode> */}
    </Provider>
  </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
